import { Box, BoxProps, useTheme } from '@mui/material';
import { FC } from 'react';

interface HelperTextProps extends BoxProps {}

const HelperText: FC<HelperTextProps> = ({ children, ...props }) => {
    const theme = useTheme();
    return (
        <Box
            {...props}
            sx={{
                color: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.7)',
                fontWeight: 400,
                fontSize: '0.65rem',
                lineHeight: 1.66,
                mt: 0.5,
                ml: 1.75,
                mr: 1.75,
                ...props.sx,
            }}
        >
            {children}
        </Box>
    );
};

export default HelperText;
